import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME, DEFAULT_OG } from "@/lib/seo";

// Central SEO tag emitter. Deepest-rendered instance wins per tag, so page-level
// <Seo> (e.g. industry/blog pages) overrides the Layout default automatically.
export const Seo = ({
  title,
  description,
  path = "",
  image = DEFAULT_OG,
  type = "website",
  suffix = true,
  schema,
}) => {
  const url = `${SITE_URL}${path}`;
  const fullTitle = suffix ? `${title} | ${SITE_NAME}` : title;
  const img = image?.startsWith("http") ? image : `${SITE_URL}${image}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};
